import apiClient from './api/client';
import { API_ENDPOINTS } from './api/endpoints';
import { Comment } from '../types/content';
import { PaginatedResponse, QueryParams } from '../types/api';

class CommentService {
  async getComments(contentType: string, contentId: string, params?: QueryParams): Promise<PaginatedResponse<Comment>> {
    return apiClient.get(`${API_ENDPOINTS.content[contentType as keyof typeof API_ENDPOINTS.content]}/${contentId}/comments`, { params });
  }

  async createComment(contentType: string, contentId: string, data: Partial<Comment>): Promise<Comment> {
    return apiClient.post(`${API_ENDPOINTS.content[contentType as keyof typeof API_ENDPOINTS.content]}/${contentId}/comments`, data);
  }

  async updateComment(id: string, data: Partial<Comment>): Promise<Comment> {
    return apiClient.put(`${API_ENDPOINTS.content.comments}/${id}`, data);
  }

  async deleteComment(id: string): Promise<void> {
    return apiClient.delete(`${API_ENDPOINTS.content.comments}/${id}`);
  }

  async likeComment(id: string): Promise<void> {
    return apiClient.post(`${API_ENDPOINTS.content.comments}/${id}/like`);
  }

  async unlikeComment(id: string): Promise<void> {
    return apiClient.post(`${API_ENDPOINTS.content.comments}/${id}/unlike`);
  }
}

export default new CommentService();